/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex';
// import { moduleActionContext, moduleGetterContext } from '@/plugins/vuex';

export interface UIState {
  tabIndex: number;
  hideTransformSourcePreview: boolean;
  hideTransformTargetPreview: boolean;
}

const module = defineModule({
  namespaced: true,
  state: (): UIState => {
    return {
      tabIndex: 0,
      hideTransformSourcePreview: false,
      hideTransformTargetPreview: false,
    };
  },
  mutations: {
    setTabIndex(state, value: number) {
      state.tabIndex = value;
    },
    sethideTransformSourcePreview(state, value: boolean) {
      state.hideTransformSourcePreview = value;
    },
    sethideTransformTargetPreview(state, value: boolean) {
      state.hideTransformTargetPreview = value;
    },
  },
});

// const uiGetterContext = (args: [any, any, any, any]) =>
//   moduleGetterContext(args, module);
// const uiActionContext = (context: any) => moduleActionContext(context, module);

export default module;
